import { SettingsRepository } from "../repositories/SettingsRepository";

export class SaveVerificationLivenessResult {
	constructor(private repository: SettingsRepository) {}

	execute(params: SaveVerificationLivenessResultParams): Promise<string> {
		return this.repository.saveVerificationLivenessResult(params.sessionId);
	}
}

export class SaveVerificationLivenessResultParams {
	constructor(public sessionId: string) {}
}
